import { useState,createContext,useEffect} from "react";
import Cookie from "js-cookie";
import Start from './components/start/Start';
import Main from './components/main/Main';
import Home from "./components/home/Home";
import Users from "./components/users/Users";
import Profile from "./components/profile/Profile";
import Profile_AnyUser from "./components/profile/Profile_AnyUser";
import Profile_Customize from "./components/profile/Profile_Customize";
import Profile_Edit from "./components/profile/Profile_Edit";
import Start_Main_SignIn from "./components/start/Start_Main_SignIn";
import Start_Main_SignUp from "./components/start/Start_Main_SignUp";
import Start_Main_Start from "./components/start/Start_Main_Start";
import { Routes, Route } from "react-router-dom";
// import Profile_Posts from "./components/profile/Profile_Posts";
// import { Auth } from "./auth/Authentication";
import './App.css';
import Messages from "./components/messages/Messages";
import Messages_Rooms from "./components/messages/Messages_Rooms";
import Messages_Search from "./components/messages/Messages_Search";
// import Messages_Room_Window from "./components/messages/Messages_Room_Window";

export const AppContext = createContext(null);

function App() {
  const [accessToken,setAccessToken] = useState(Cookie.get("jwttoken")||'');
  useEffect(() => {
    // const token = Cookie.get("jwttoken");
    // console.log(token);
    // if (token) {
    //   setAccessToken(token);
    // }
    console.log('accessToken>>>>>>',accessToken);
  },[])
  
  return (
    <AppContext.Provider value={{accessToken,setAccessToken}}>
      <div className="App">
        <Routes>
            <Route path="start" element={<Start />} >
              <Route index element={<Start_Main_Start />} />
              <Route path="signin" element={<Start_Main_SignIn />} />
              <Route path="signup" element={<Start_Main_SignUp />} />
            </Route>
            {/* <Route path="/" element={<Auth><Main /></Auth>} > */}
            <Route path="/" element={<Main />} >
              <Route index element={<Home />} />
              <Route path="users" element={<Users />} />
              <Route path="messages/:id" element={<Messages />}>
                <Route index element={<Messages_Rooms />} >
                  {/* <Route index element= /> */}
                </Route>
                <Route path="search" element={<Messages_Search />} />
              </Route>
              {/* <Route path="profile" element={
                <>
                  <div className="main_content_section_main">
                    <Profile />
                    <Profile_Posts /> 
                  </div>
                </>
              } /> */}
              <Route path="profile" element={<Profile />} />
              <Route path="profile/:id" element={<Profile_AnyUser />} />
              <Route path="profile/customize" element={<Profile_Customize />} />
              <Route path="profile/edit" element={<Profile_Edit />} />
            </Route>
        </Routes>
      </div>
    </AppContext.Provider>
    
  );
}

export default App;
